import { Link } from "react-router-dom";
import { Phone, WhatsappLogo, MapPin, EnvelopeSimple, InstagramLogo, FacebookLogo, ArrowRight, ShieldCheck, SealCheck } from "@phosphor-icons/react";

const MEB_VERIFY_URL = "https://mebbis.meb.gov.tr/ookkarekod.aspx?kkod=299832501";
const MEB_DOC_NO = "99942149";

export default function Footer() {
  return (
    <footer className="bg-brand-ink text-stone-300 mt-24" data-testid="footer">
      {/* CTA strip */}
      <div className="border-b border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-12 grid md:grid-cols-2 gap-6 items-center">
          <div>
            <div className="text-[11px] font-semibold tracking-[0.15em] uppercase text-brand-primary mb-3">Kayıtlar Açık · 2026</div>
            <h3 className="font-heading text-3xl md:text-4xl font-bold text-white tracking-tight">Ehliyetiniz için ilk adımı atın.</h3>
            <p className="mt-2 text-stone-400 max-w-md">5 dakika içinde online başvurunuzu tamamlayın, eğitim sürecinizi başlatın.</p>
          </div>
          <div className="flex flex-col sm:flex-row gap-3 md:justify-end">
            <Link to="/basla" className="nb-btn !bg-white !text-brand-ink hover:!bg-stone-100">Online Kayıt Başvurusu <ArrowRight weight="bold" size={16}/></Link>
            <a href="tel:+902626463646" className="nb-btn-outline !bg-transparent !border-white/20 !text-white hover:!bg-white/5"><Phone weight="bold" size={16}/> 0262 646 3 646</a>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="grid md:grid-cols-12 gap-10">

          {/* Logo + MEB Verification */}
          <div className="md:col-span-4">
            <div className="bg-white inline-block p-3 rounded-xl mb-4">
              <img src="/estem-logo.png" alt="Estem Sürücü Kursu" className="h-14 w-auto object-contain"/>
            </div>
            <p className="text-sm text-stone-400 leading-relaxed">1989 yılından bu yana Gebze ve Kocaeli'nde sürücü eğitimi alanında MEB onaylı, güvenilir ve köklü bir kurum olarak faaliyetlerimizi sürdürüyoruz.</p>

            {/* MEB Verification Block */}
            <a
              href={MEB_VERIFY_URL}
              target="_blank"
              rel="noreferrer"
              data-testid="meb-verify-link"
              className="mt-6 flex items-start gap-4 p-4 rounded-2xl border border-white/10 bg-white/5 hover:bg-white/10 hover:border-brand-primary/40 transition-all group"
            >
              {/* QR Code */}
              <div className="shrink-0 bg-white p-1.5 rounded-lg">
                <img
                  src="/meb-qr.jpg"
                  alt="MEB QR Doğrulama Kodu"
                  className="w-16 h-16 object-contain"
                  data-testid="meb-qr-image"
                />
              </div>

              {/* Info */}
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-1.5 mb-1">
                  <SealCheck weight="fill" className="text-brand-primary shrink-0" size={15}/>
                  <span className="text-[10px] font-bold uppercase tracking-wider text-brand-primary">MEB Onaylı Kurum</span>
                </div>
                <div className="text-xs text-stone-400 leading-relaxed">
                  Belge No: <span className="font-bold text-white font-mono">{MEB_DOC_NO}</span>
                </div>
                <div className="text-[11px] text-stone-500 mt-1 leading-tight">
                  QR kodu tarayarak MEB'in resmi sayfasından doğrulayabilirsiniz.
                </div>
                <div className="mt-2 text-[10px] text-brand-primary group-hover:underline">
                  mebbis.meb.gov.tr →
                </div>
              </div>
            </a>
          </div>

          <div className="md:col-span-2">
            <div className="text-[11px] font-semibold tracking-[0.15em] uppercase text-stone-500 mb-4">Kurumsal</div>
            <div className="space-y-2.5 text-sm">
              <Link to="/hakkimizda" className="block text-stone-400 hover:text-white transition-colors">Hakkımızda</Link>
              <Link to="/blog" className="block text-stone-400 hover:text-white transition-colors">Blog</Link>
              <Link to="/sss" className="block text-stone-400 hover:text-white transition-colors">S.S.S.</Link>
              <Link to="/fiyatlar" className="block text-stone-400 hover:text-white transition-colors">Fiyatlar</Link>
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="text-[11px] font-semibold tracking-[0.15em] uppercase text-stone-500 mb-4">Kurslar</div>
            <div className="space-y-2.5 text-sm">
              <Link to="/kurs/b-sinifi" className="block text-stone-400 hover:text-white transition-colors">B Sınıfı (Manuel)</Link>
              <Link to="/kurs/b-otomatik" className="block text-stone-400 hover:text-white transition-colors">B Sınıfı (Otomatik)</Link>
              <Link to="/kurs/a1" className="block text-stone-400 hover:text-white transition-colors">A1 — Motosiklet (125cc)</Link>
              <Link to="/kurs/a2" className="block text-stone-400 hover:text-white transition-colors">A2 — Motosiklet</Link>
              <Link to="/kurs/a" className="block text-stone-400 hover:text-white transition-colors">A — Motosiklet</Link>
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="text-[11px] font-semibold tracking-[0.15em] uppercase text-stone-500 mb-4">İletişim</div>
            <div className="space-y-3 text-sm">
              <a href="tel:+902626463646" className="flex items-start gap-2.5 text-stone-400 hover:text-white"><Phone weight="bold" className="mt-0.5 text-brand-primary shrink-0" size={16}/> 0262 646 3 646</a>
              <a href="https://wa.me/+905436566346" target="_blank" rel="noreferrer" className="flex items-start gap-2.5 text-stone-400 hover:text-white"><WhatsappLogo weight="bold" className="mt-0.5 text-brand-primary shrink-0" size={16}/> 0543 656 6 346</a>
              <a href="mailto:info@estemsurucukursu.com" className="flex items-start gap-2.5 text-stone-400 hover:text-white break-all"><EnvelopeSimple weight="bold" className="mt-0.5 text-brand-primary shrink-0" size={16}/> info@estemsurucukursu.com</a>
              <a href="https://goo.gl/maps/prHGbUQpr71FUoAv7" target="_blank" rel="noreferrer" className="flex items-start gap-2.5 text-stone-400 hover:text-white"><MapPin weight="bold" className="mt-0.5 text-brand-primary shrink-0" size={16}/> Hacıhalil Mahallesi Zübeyde Hanım Caddesi Gümgüm İş Merkezi Kat:1, 41400 Gebze/Kocaeli</a>
            </div>
            <div className="mt-5 pt-5 border-t border-white/10">
              <div className="text-[11px] font-semibold tracking-[0.15em] uppercase text-stone-500 mb-2">Çalışma Saatleri</div>
              <p className="text-sm text-stone-400 leading-relaxed">Pzt-Cum: 09:00 – 19:00<br/>Cmt: 09:00 – 18:00<br/>Pazar: Kapalı</p>
            </div>
            <div className="mt-5 flex gap-2">
              <a href="#" aria-label="Instagram" className="w-9 h-9 border border-white/15 rounded-md flex items-center justify-center hover:bg-white/5 hover:border-white/30 transition-colors"><InstagramLogo weight="bold" size={16}/></a>
              <a href="#" aria-label="Facebook" className="w-9 h-9 border border-white/15 rounded-md flex items-center justify-center hover:bg-white/5 hover:border-white/30 transition-colors"><FacebookLogo weight="bold" size={16}/></a>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-14 pt-6 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-stone-500">
          <div>© {new Date().getFullYear()} Estem Sürücü Kursu — Tüm hakları saklıdır.</div>
          <div className="flex items-center gap-4">
            <span>Gebze · Kocaeli · Türkiye</span>
            <a href={MEB_VERIFY_URL} target="_blank" rel="noreferrer"
               className="flex items-center gap-1.5 hover:text-stone-300 transition-colors"
               data-testid="meb-bottom-verify">
              <ShieldCheck weight="fill" className="text-brand-primary" size={14}/>
              MEB Belge No: {MEB_DOC_NO}
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
